import React from 'react';

import { COLUMN_NAME_ID } from '../../../constants';
import type { CellWithCustomColumnConfig } from '../../../pages/Trafficking/TraffickingPage/columns';
import type { EntityModel } from '../../../pages/Trafficking/TraffickingPage/modelConverters';
import CellElement from '../CellElement';

type Props = {
  cells: CellWithCustomColumnConfig<EntityModel>[];
  selectedColIndex: number;
  selectedRowIndex: number;
  isRowSelected: boolean;
};

const TraffickingTableCells = ({ cells, selectedColIndex, selectedRowIndex, isRowSelected }: Props): JSX.Element => (
  <>
    {cells.map((cell: CellWithCustomColumnConfig<EntityModel>, colIndex: number) => {
      const { id, isEditable, doNotLighten, className, maxWidth, width: columnWidth } = cell.column;
      let cssClass = className;
      const isPossibleToSelectRow = id !== COLUMN_NAME_ID && !isEditable;
      const cellKey = cell.getCellProps().key;
      if ('doNotTraffic' in cell.row.original && Boolean(cell.row.original.doNotTraffic) && !doNotLighten)
        cssClass = `${cssClass} do-not-traffic`;

      return (
        <CellElement
          key={cellKey}
          colIndex={colIndex}
          selectedColIndex={selectedColIndex}
          selectedRowIndex={selectedRowIndex}
          isEditable={isEditable}
          rowIndex={cell.row.index}
          className={cssClass}
          maxWidth={maxWidth}
          getCellProps={cell.getCellProps}
          render={cell.render}
          isPossibleToSelectRow={isPossibleToSelectRow}
          entity={cell.row.original}
          isRowSelected={isRowSelected}
          columnWidth={columnWidth}
        />
      );
    })}
  </>
);

export default TraffickingTableCells;
